import { Store } from "lucide-react";
import { useCart } from "@/context/CartContext";

export const OutletPicker = () => {
  const { outlet, setOutlet, shop } = useCart();
  if (!shop.outlets.length) return null;
  const cls = "inline-flex items-center gap-2 px-3 py-2.5 rounded-xl border border-ink/20 bg-paper text-sm font-medium";
  if (shop.outlets.length === 1) {
    const o = shop.outlets[0];
    return <span className={cls} data-testid="outlet-label"><Store className="w-4 h-4" /> Gerai {o.name}</span>;
  }
  return (
    <label className={cls}>
      <Store className="w-4 h-4" />
      <select value={outlet} onChange={(e) => setOutlet(e.target.value)} className="bg-transparent focus:outline-none" data-testid="outlet-select">
        {shop.outlets.map((o) => <option key={o.code} value={o.code}>Gerai {o.name}</option>)}
      </select>
    </label>
  );
};
